var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useGame } from '@0g/react';
import * as React from 'react';
import { AddComponentButton } from './AddComponentButton';
import { List, ListItem } from './components/List';
import { PanelHeader } from './components/Panel';
import { useForceUpdate } from './hooks/useForceUpdate';
import { ComponentEditor } from './ComponentEditor';
import { useStore } from './useStore';
export function EntityDetails(_a) {
    var update = useForceUpdate();
    var entityId = useStore(function (s) { return s.selectedEntityId; });
    var game = useGame();
    var _b = __read(React.useState(new Array()), 2), components = _b[0], setComponents = _b[1];
    // rerender if stores change
    React.useEffect(function () {
        var _a;
        if (!entityId)
            return;
        var ent = game.get(entityId);
        setComponents(Array.from((_a = ent === null || ent === void 0 ? void 0 : ent.components.values()) !== null && _a !== void 0 ? _a : []));
        function onAddComponent(id, component) {
            if (id !== entityId)
                return;
            setComponents(function (cur) {
                cur[component.__type] = component;
                return cur;
            });
        }
        function onRemoveComponent(id, componentType) {
            if (id !== entityId)
                return;
            setComponents(function (cur) {
                delete cur[componentType];
                return cur;
            });
        }
        game.archetypeManager.on('entityComponentAdded', onAddComponent);
        game.archetypeManager.on('entityComponentRemoved', onRemoveComponent);
        return function () {
            game.archetypeManager.off('entityComponentAdded', onAddComponent);
            game.archetypeManager.off('entityComponentRemoved', onRemoveComponent);
        };
    }, [entityId]);
    if (!entityId) {
        return React.createElement(React.Fragment, null, "No entity");
    }
    return (React.createElement(React.Fragment, { key: entityId },
        React.createElement(PanelHeader, null,
            React.createElement("h3", null, entityId),
            React.createElement(AddComponentButton, { entityId: entityId })),
        React.createElement(List, { css: { minWidth: 400 } }, components.map(function (comp) {
            if (!comp)
                return null;
            return (React.createElement(ListItem, { key: Object.getPrototypeOf(comp).name },
                React.createElement(ComponentEditor, { component: comp })));
        }))));
}
//# sourceMappingURL=EntityDetails.js.map